import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box, Grid2, MenuItem, Select, Skeleton, Typography, useTheme } from "@mui/material";
import { IoIosArrowDown } from "react-icons/io";
import { useParams } from "react-router-dom";
import { useGetClaimsOpenByContractorQuery } from "store/slices/apis/claimsAndChangeOrderDashboardSlice";
import ClaimsPopup from "./ClaimsPopup";

const OpenClaimsByContractor = () => {
    const theme = useTheme();

    const { projectId } = useParams();
    const [popupData, setPopupData] = useState(null);
    const [open, setOpen] = useState(false);
    const { data, isLoading } = useGetClaimsOpenByContractorQuery({ projectId });
    const [chartData, setChartData] = useState({
        categories: [],
        series: [],
    });
    useEffect(() => {
        if (data?.data && Array.isArray(data?.data)) {
            const categories = data?.data?.map(item => item?.contractor);
            const series = data?.data.map(item => ({
                y: item?.count,
                name: item?.contractor,
                color: "#B02E2A",
            }));
            setChartData({ categories, series });
        }
    }, [data]);

    const chartOptions = {
        chart: {
            type: "column",
            // height: "100%",
        },
        title: {
            text: "",
            align: "left",
            style: {
                fontSize: "14px",
                fontWeight: "bold",
                color: "#21325B",
            },
        },
        xAxis: {
            // lineWidth: 0,
            rotation: -45,
            crosshair: true,
            categories: chartData?.categories,
            labels: {
                style: {
                    fontWeight: 500,
                    color: "#00000080",
                    fontSize: '12px'
                },
            },
        },
        yAxis: {
            min: 0,
            title: {
                text: "",
            },
            labels: {
                format: '{value}'
            },
            // gridLineWidth: 0,
            lineWidth: 1,
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                groupPadding: 0.1,
            },
        },
        colors: ["#B02E2A"],
        series: [
            {
                name: "Open Claims by Contractor",
                data: chartData?.series,
                point: {
                    events: {
                        click: function () {
                            setPopupData({
                                contractor: this.name,
                                value: this.y,
                            });
                            setOpen(true);
                        },
                    },
                },
            }
        ],
        credits: {
            enabled: false,
        },
        legend: {
            enabled: false,
            align: "left",
            itemDistance: 40,
            alignColumns: false,
            reversed: true,
            x: 50,
            y: 0
        },
        tooltip: {
            enabled: true,
        },
    };

    return (
        <Box sx={{ backgroundColor: "white", border: "1px solid #D8D8D8", borderRadius: "12px", height: "100%" }}>
            {/* <Grid2 container>
                <Grid2 size={{ xs: 12, md: 6 }}> */}
            <Box sx={{ margin: '0 auto', paddingLeft: "25px" }}>
                <Typography variant="h6" sx={{ mb: 1, color: `${theme?.customSettings?.themeColor}`, fontWeight: "500", fontSize: '18px', paddingTop: "22px", lineHeight: "100%", letterSpacing: "0.4px" }}>
                    Open Claims by Contractor
                </Typography>
                <Typography variant="body2" sx={{ mb: 2, color: "#182A4E80" }}>
                    Analyze contractor-specific claims to identify patterns and improve contract performance.
                </Typography>
            </Box>
            {/* </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                    <Box sx={{ width: '100%', display: "flex", justifyContent: 'end' }}>
                        <Select
                            labelId="demo-simple-select-standard-label"
                            id="demo-simple-select-standard"
                            value={10}
                            IconComponent={IoIosArrowDown}
                            sx={{
                                backgroundColor: '#E8E8E8',
                                '& .MuiOutlinedInput-input': {
                                    padding: '5px 15px'
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none'
                                }
                            }}
                        >
                            <MenuItem value={10}>Value</MenuItem>
                        </Select>
                    </Box>
                </Grid2>
            </Grid2> */}

            <Box sx={{ paddingLeft: "10px", marginTop: "30px" }}>
                {isLoading ? (
                    <Skeleton variant="rectangular" height={300} animation="wave" />
                ) : (chartData.series.length === 0 ? (
                    <Box
                        sx={{
                            height: 300,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#999',
                            fontSize: 16,
                        }}
                    >
                        No data available to display the chart.
                    </Box>
                ) : (
                    <HighchartsReact highcharts={Highcharts} options={chartOptions} />
                ))}
            </Box>
            {open && (() => {
                return (
                    <ClaimsPopup title={'Open Claims by Contractor'} value={popupData?.contractor} status={'openClaimsByContractor'} onOpen={open} onClose={() => setOpen(false)} />
                )
            })()}
        </Box>
    );
};

export default OpenClaimsByContractor;
